import casusBackend, {PageItemCasusSearchItem} from '@lexian/api/casus-api';
import {SearchCasusFilters} from '_/types/casus';
import {handlePaginatedLoadableFetch} from '_/utilities/simple-fetch';
import {
  defaultPaginationArguments,
  PaginatedLoadable,
  PaginationArgumentsWithoutCursor,
} from '_/utilities/types';

const defaultSearchCasusFilters: SearchCasusFilters = {
  lockedFilter: 'ALL',
  stateFilters: ['ACTIVE', 'INACTIVE', 'ARCHIVED'],
  type: 'ALL',
  protectedFilter: 'ALL',
  invoiceableFilter: 'ALL',
  exactSearch: false,
};

export const assignableCasusFilters: SearchCasusFilters = {
  ...defaultSearchCasusFilters,
  lockedFilter: 'UNLOCKED',
  stateFilters: ['ACTIVE'],
};

export const searchCasus =
  (filters: SearchCasusFilters = defaultSearchCasusFilters) =>
  (
    paginationArguments: PaginationArgumentsWithoutCursor = defaultPaginationArguments,
    currentLoadable: PaginatedLoadable<PageItemCasusSearchItem[]>,
    {searchQuery, ids}: {searchQuery: string; ids?: string[]}
  ): Promise<PaginatedLoadable<PageItemCasusSearchItem[]>> =>
    handlePaginatedLoadableFetch(
      {
        endpointFunction: ({parameters, ...rest}) =>
          casusBackend.searchAllCasus({
            parameters: {
              ...filters,
              ...parameters,
            },
            ...rest,
          }),
        otherParams: {query: searchQuery, ids},
        getPageItemFromResponse: (body) => body.casus,
      },
      paginationArguments,
      currentLoadable
    );

export const searchAssignableCasus = searchCasus(assignableCasusFilters);
